import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { DriversState } from '../../types';

import { addDriverFuelAssignment as addDriverFuelAssignmentOperation } from '../operations/addDriverFuelAssignment';

import { STATUS_LOADING } from 'common/constants';

export const addDriverFuelAssignment = (builder: ActionReducerMapBuilder<DriversState>) => builder
  .addCase(addDriverFuelAssignmentOperation.pending, (state) => {
    state.fuelAssignment.addingStatus = STATUS_LOADING.load;
  })
  .addCase(addDriverFuelAssignmentOperation.fulfilled, (state) => {
    state.fuelAssignment.addingStatus = STATUS_LOADING.done;
  })
  .addCase(addDriverFuelAssignmentOperation.rejected, (state) => {
    state.fuelAssignment.addingStatus = STATUS_LOADING.error;
  });